// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../GeneratePriceModal/GeneratePriceModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-description {
    font-size: 14px;
    color: #6C748B;
    margin-top: -10px;
    margin-bottom: 24px;
}

.checkin-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.checkin-input-group label {
    display: block;
    font-size: 14px;
    color: #3A445D;
    margin-bottom: 8px;
}

.checkin-input-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #D9DCE1;
    border-radius: 8px;
    font-size: 14px;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.checkin-input-group input:focus {
    outline: none;
    border-color: #00875A;
    box-shadow: 0 0 0 3px rgba(0, 135, 90, 0.2);
}

.confirm-btn {
    background-color: #00875A;
    color: white;
    border: none;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
}

.confirm-btn:hover:not(:disabled) {
    background-color: #00694a;
}

.confirm-btn:disabled {
    background-color: #cce8e0;
    cursor: not-allowed;
}

@media (max-width: 600px) {
  .checkin-form { gap: 12px; }
  .confirm-btn { padding: 8px 16px; font-size: 14px; }
}`, "",{"version":3,"sources":["webpack://./src/compoonents/ParcelCheckinModal/ParcelCheckinModal.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;EACE,gBAAgB,SAAS,EAAE;EAC3B,eAAe,iBAAiB,EAAE,eAAe,EAAE;AACrD","sourcesContent":["@import '../GeneratePriceModal/GeneratePriceModal.css';  \n\n.modal-description {\n    font-size: 14px;\n    color: #6C748B;\n    margin-top: -10px;\n    margin-bottom: 24px;\n}\n\n.checkin-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.checkin-input-group label {\n    display: block;\n    font-size: 14px;\n    color: #3A445D;\n    margin-bottom: 8px;\n}\n\n.checkin-input-group input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #D9DCE1;\n    border-radius: 8px;\n    font-size: 14px;\n    box-sizing: border-box;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.checkin-input-group input:focus {\n    outline: none;\n    border-color: #00875A;\n    box-shadow: 0 0 0 3px rgba(0, 135, 90, 0.2);\n}\n\n.confirm-btn {\n    background-color: #00875A;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.confirm-btn:hover:not(:disabled) {\n    background-color: #00694a;\n}\n\n.confirm-btn:disabled {\n    background-color: #cce8e0;\n    cursor: not-allowed;\n}\n\n@media (max-width: 600px) {\n  .checkin-form { gap: 12px; }\n  .confirm-btn { padding: 8px 16px; font-size: 14px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
